if (!customElements.get('form-validation')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.inputs = this.querySelectorAll('.field input');
    }

    setFieldValidity(input) {
      let isValud = false;
      let emailIsValid = false;
      let hasSompass = false;

      this.inputs.forEach(thisInput => {
        if (thisInput.type == 'email' && thisInput.value != '') {
          emailIsValid = true
        }

        if (thisInput.type === 'password' && thisInput.value != '') {
          hasSompass = true
        }
      });

      if (hasSompass && emailIsValid) {
        isValud = true
      };

      isValud ? this.button.disabled = false : this.button.disabled = true
    }

    setEventHandlers() {
      for (const input of this.form.elements) {
        ['focusout', 'input'].forEach(eventName => {
          input.addEventListener(eventName, () => {
            this.setFieldValidity(input);
          });
        });
      }
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.setEventHandlers();
    }
  }

  customElements.define('form-validation', FormValidation);
}
